
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import AppRating from 'frontend/views/landing/AppRating.vue';
import TrustpilotRating from 'frontend/views/landing/TrustpilotRating.vue';
import PublishersList from 'frontend/views/landing/PublishersList.vue';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    PublishersList,
    AppRating,
    TrustpilotRating,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LandingHeroV2 extends Vue {
  @Prop({ type: String, required: true }) readonly videoUrl!: string;
  @Prop({ type: Object, required: true }) readonly ctaAxParams!: object;
  @Prop({ type: Boolean, default: true }) readonly showPublisherLogos!: boolean;
  @Prop({ type: Boolean, required: false }) readonly isMathcounts!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isExperiment!: boolean;
  @Prop({ type: String, default: 'Get started' }) ctaButtonText!: string;

  private isMobile!: MobileGetter;

  private get getStartedHref(): string {
    let route = 'nux_welcome';
    if (this.isMathcounts) {
      route = 'teacher_landing';
    }
    return this.$router.resolve({ name: route }).href;
  }

  private getStartedClickHandler(event: any): void {
    if (!this.isMathcounts) {
      event.preventDefault();
      this.$router.push({ name: 'nux_welcome' });
    }
  }
}
